<template>
    <div>
        <PageHeaderLayout>
            <div class="main-page-content" style="margin-top: 20px;">
                <el-row>
                    <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="公司名称">
                            <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="开通状态" prop="is_wallet">
                            <el-select v-model="searchCondition.is_wallet" filterable clearable placeholder="请选择">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchButton">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-tabs v-model="company_type" type="card" @tab-click="handleClick" >
                    <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
                    </el-tab-pane>
                </el-tabs>
                <ApeTable v-permission:withoutCard_list
                    ref="apeTable"
                    :data="dataList"
                    :columns="columns"
                    :loading="loadingStaus"
                    :pagingData="pagingData"
                    highlight-current-row
                    @switchPaging="switchPaging"
                >
                <el-table-column
                    align="center"
                    label="开通状态">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.is_wallet==1?'已开通':'未开通'}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    align="center"
                    label="操作"
                >
                        <template slot-scope="scope">
                            <el-switch v-permission:withoutCard_opr
                              v-model="scope.row.is_wallet"
                              @change="switchButton($event,scope.row.id)"
                              :active-value="1"
                              :inactive-value="0">
                            </el-switch>
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
    </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
import ApeTable from "@/components/ApeTable";
import tzForm from "@/components/tz-form";
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'
export default {
    components: {
        tzForm,
        PageHeaderLayout,
        ApeTable,
        ModalDialog,
        UploadFile,
        DatePicker
    },
    data() {
        return {
            loadingStaus: false,
            company_type: '1',
            tabsList: [
                {
                    label: '人资公司',
                    name: '1'
                },
                {
                    label: '用工企业',
                    name: '2'
                },
            ],
            // 分页信息
            pagingData:{
                is_show: true,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                offset:0
            },
            dataList: [],
            columns: [
                {
                    title: "公司名称",
                    value: "company_name",
                    header_align: "center",
                    align: "center",
                }
            ],
            searchCondition:{
                status:'',
                company_name:'',
            },
            typeList:[
                {id:'0',name:'未开通'},
                {id:'1',name:'已开通'},
            ],
        };
    },
    watch: {
    },
    methods: {
        // 重置分页
        async resetPage() {
            this.$refs.apeTable.currentPage = 1
        },
        // 切换页码操作
        async switchPaging() {
            this.init();
        },
        // 搜索
        searchButton() {
            this.resetPage()
            this.init('search')
        },
        //获取列表
        async init(type) {
            this.loadingStaus=true
            let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
            let searchCondition = this.handleSearchCondition()
            Object.assign(searchCondition,pagingInfo)
            this.dataList = []
            let { data, pages} = await this.$api.getPayWithoutCardCompanyList(searchCondition)
            this.$nextTick(() => {
                this.dataList=data
            })
            this.pagingData.total = pages.total
            this.offset = pages.offset
            this.loadingStaus=false
        },
        // 处理搜索条件
        handleSearchCondition() {
            let condition = {}
            if (this.searchCondition.company_name) {
                condition.company_name = this.searchCondition.company_name
            }
            if (this.searchCondition.is_wallet) {
                condition.is_wallet = this.searchCondition.is_wallet
            }
            
            if(this.company_type){
                condition.company_type = this.company_type
            }
            
            return condition
        },
        //点击tab切换
        async handleClick(tab) {
            this.searchCondition={is_wallet:'',company_name:''};
            this.company_type = tab.name;
            this.resetPage()
            this.init()
        },
        
        // 删除商户
        async switchButton(e,id) {
            console.log(e,this.company_type)
            let data = {
                is_wallet:e,
                company_type:this.company_type
            }
          let result = await this.$api.switchWalletStatus(id,data)
          if(result) {
            this.$message.success('修改成功')
            this.init()
          }
        },
        
    },
    computed: {
        ...mapGetters(['userPermissions'])
    },
    mounted() {
        this.resetPage()
        this.init();
    },
};
</script>

<style lang="scss" scoped>
    .agree-class{
        margin: 20px;
    }
    .foot-btn,.agree-class{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .auth-tips{
        text-align: left;
        &>div:first-child{
            margin-bottom: 30px;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            color: #333;
            line-height: 1.6;
        }
        &> div {
            margin: 10px 0;
            text-indent: 2em;
            
            .qrcode{
                margin: auto;
                display: block;
                margin-top: 10px;
                width: 100px;
                height: 100px;
            }
            
            span{
                font-size: 14px;
                font-weight: 600;
                color: #333;
                line-height: 1.6;
            }
        }
    }
</style>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0
.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

el-radio-group{
 display :flex;    
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
}

.invoice-img {
  width: 100%
}
.new-mail-img
  width: 100%
  display: none
.mail-img
  width: 100%
.mail-title
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.mail-content
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.invoice-wrapper
  margin-left: 55px
.expend
  text-align: center
  margin-top: 20px
  color: #333
/deep/.vue-uploader
  width: 98%
</style>